import type { HTMLAttributes } from 'react';

interface MiniappSurfaceProps extends HTMLAttributes<HTMLDivElement> {
  tone?: 'default' | 'muted';
}

export function MiniappSurface({
  tone = 'default',
  className = '',
  ...props
}: MiniappSurfaceProps) {
  const toneClass =
    tone === 'muted'
      ? 'bg-[rgba(255,248,231,0.62)]'
      : 'bg-[rgba(255,248,231,0.88)]';

  return (
    <div
      className={[
        'rounded-[var(--surface-radius)] border border-[rgba(26,26,26,0.06)] shadow-[0_8px_18px_rgba(62,48,23,0.06)] min-[430px]:rounded-[var(--surface-radius-comfortable)] min-[430px]:shadow-[0_12px_28px_rgba(62,48,23,0.08)]',
        toneClass,
        className,
      ].join(' ')}
      {...props}
    />
  );
}
